import { MarketButton } from '@market/react';
import { useTranslation } from 'react-i18next';
import { withI18n } from '@squareup/service-i18n/components';
import { BankingModalPartial } from '../../../ui/modal/BankingModalPartial';
import { CardPreviewFront } from '../../card-preview/CardPreviewFront';
import styles from './CardActivationUpsellModal.module.css';

export interface CardActivationUpsellModalProps {
  readonly active: boolean;
  readonly cardName: string;
  readonly businessName: string;
  readonly signatureDataUri?: string;
  readonly onActivateCardClick: () => void;
  readonly onRemindMeLaterClick: () => void;
}

export const CardActivationUpsellModal = ({
  active, businessName, cardName, signatureDataUri, onActivateCardClick, onRemindMeLaterClick,
}: CardActivationUpsellModalProps) => {
  const { t } = useTranslation();

  const buttons = [
    <MarketButton key="activate_button" rank="primary" onClick={onActivateCardClick}>
      {t('bankingShared.card.upsellModal.button.activate')}
    </MarketButton>,
    <MarketButton key="remind_button" onClick={onRemindMeLaterClick}>
      {t('bankingShared.card.upsellModal.button.remind')}
    </MarketButton>,
  ];

  const content = (<div className={styles.content}>
    <p className="paragraph-30">{t('bankingShared.card.upsellModal.description', { cardName })}</p>
    <div>
      <CardPreviewFront className={styles.cardPreview} businessName={businessName} signatureDataUri={signatureDataUri || ''} />
    </div>
  </div>);
  return (<BankingModalPartial
    active={active}
    buttons={buttons}
    content={content}
    title={t('bankingShared.card.upsellModal.title')}
    onModalClose={onRemindMeLaterClick}
  />);
};

export const CardActivationUpsellModalI18n = withI18n(CardActivationUpsellModal);
